import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center align-items-center w-100 h-100" }
const _hoisted_2 = {
  class: "rounded-3 p-4 p-sm-5 w-100 shadow-lg",
  style: {"max-width":"450px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3" }, "Přihlášení", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_LoginForm)
    ])
  ]))
}